// 광고 노출 게이트 신호 저장소 — 전부 「모름」에서 시작한다 (ports/ad-gate.ts). MVP 는 아는 만큼 넣는다:
//   adGateStore.set({ adultContentVisible: false, paidUser: false, country: 'US', consent: true });
import { useSyncExternalStore } from 'react';

import type { AdGateSignals, AdGateStore, AdRewardSwitch } from '../ports/ad-gate';

const UNKNOWN: AdGateSignals = Object.freeze({});

export function createAdGateStore(): AdGateStore {
  let current: AdGateSignals = UNKNOWN;
  const listeners = new Set<() => void>();
  return {
    get: () => current,
    set(patch) {
      current = Object.freeze({ ...current, ...patch });
      listeners.forEach(notify => notify());
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}

/** 앱 하나에 게이트 신호 하나 */
export const adGateStore: AdGateStore = createAdGateStore();

/** 지금 게이트 신호. 서버 렌더에서는 전부 「모름」이다 */
export function useAdGate(): AdGateSignals {
  return useSyncExternalStore(adGateStore.subscribe, adGateStore.get, () => UNKNOWN);
}

export function createAdRewardSwitch(): AdRewardSwitch {
  let on = false;
  const listeners = new Set<() => void>();
  return {
    get: () => on,
    set(next) {
      if (next === on) return;
      on = next;
      listeners.forEach(notify => notify());
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}

/** 앱 하나에 광고 보상 스위치 하나 — ad-reward 플러그인이 켠다 (ports/ad-gate.ts AdRewardSwitch) */
export const adRewardSwitch: AdRewardSwitch = createAdRewardSwitch();

/** 이 앱이 보상형 광고를 켜 두었는가. 서버 렌더에서는 false */
export function useAdRewardOn(): boolean {
  return useSyncExternalStore(adRewardSwitch.subscribe, adRewardSwitch.get, () => false);
}
